const getQueryBuilderError = (applicability, applicabilityModeType) => {
  if (applicability) {
    if (
      Object.keys(applicability).includes('caseList') &&
      applicabilityModeType !== 'single'
    ) {
      // Check case list validation
      const hasCaseErrors = applicability?.caseList.some(
        (element) => element?.whenError !== '' || element?.thenError !== ''
      );
      return hasCaseErrors || applicability?.elseError !== '';
    }
    // Check single query validation
    if (!applicability?.query || (applicability?.errors?.length ?? 0) > 0) {
      return !applicability?.query || (applicability?.errors?.length ?? 0) > 0;
    }
    if (applicability?.query?.children1?.length === 0) {
      return true;
    }
  }
  return false;
};

export default getQueryBuilderError;
